/* istanbul ignore file */

// declarative file
export enum FileContentType {
  JPG = 'image/jpg, image/jpeg',
  GIF = 'image/gif',
  PNG = 'image/png',
  PDF = 'application/pdf',
  DOC = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  DOCX = 'application/docx',
  ODT = 'application/vnd.oasis.opendocument.text',
}
